// Section 22 Policies tab root: all 23 Section 18 policies as a grouped form. Changes go into
// the draft (setPolicy) and apply from next season; every control shows who it affects.
import { draft, game, runConfig, setPolicy, status } from '../../store';
import type { Policies, PolicyId } from '../../sim/api';
import { policiesVM } from '../../viewModels';
import { uiText } from '../text/en';
import { PolicyControl } from './policy-control';
import './policies.css';

export function PoliciesTab() {
  const g = game.value;
  if (g === null) return null;
  const vm = policiesVM(g, draft.value, runConfig());
  const canEdit = status.value === 'deciding';
  const t = uiText.policies;
  const onChange = (id: PolicyId, value: unknown): void => {
    setPolicy(id, value as Policies[PolicyId]);
  };
  return (
    <form class="policies" onSubmit={(e) => e.preventDefault()} aria-labelledby="policies-title">
      <h2 id="policies-title" class="visually-hidden">
        {t.title}
      </h2>
      <p class="hint" role="status">
        {vm.changed === 0 ? t.unchanged : t.changed(vm.changed)}
      </p>
      {vm.groups.map((group) => (
        <fieldset key={group.id} class="policies__group">
          <legend>{t.groups[group.id] ?? group.id}</legend>
          {group.policies.map((p) => (
            <PolicyControl key={p.id} vm={p} lists={vm} canEdit={canEdit} onChange={onChange} />
          ))}
        </fieldset>
      ))}
    </form>
  );
}
